import { IAppState } from '../../redux';
import { TPaymentStatus } from '../../types/reducers/depositAccount';

export function selectDepositAccountPaymentStatus(state: IAppState): TPaymentStatus {
  return state.depositAccount.paymentStatus;
}
